import { useLocation, useNavigate, useRouteError, isRouteErrorResponse } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertOctagon, ArrowLeft, Bug } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const routeError = useRouteError();

  useEffect(() => {
    if (isRouteErrorResponse(routeError)) {
      // True unmatched route or thrown Response
    } else if (routeError) {
      // Rendered as an error boundary for a matched route
    } else {
      // Fallback: unknown reason this component rendered
    }
  }, [location.pathname, routeError]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background animate-fadeIn">
      <div className="text-center space-y-6 p-8 rounded-lg">
        <AlertOctagon className="mx-auto h-16 w-16 text-primary" />
        
        <div className="space-y-2">
          <h1 className="text-4xl font-bold">404</h1>
          <p className="text-xl text-muted-foreground">
            Oops! We couldn't find that page
          </p>
          <p className="text-sm text-muted-foreground">
            The page you're looking for doesn't exist or has been moved
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Button
            variant="default"
            onClick={() => navigate("/")}
            className="w-full sm:w-auto"
          >
            <ArrowLeft className="mr-2" />
            Return Home
          </Button>
          
          <Button
            variant="outline"
            onClick={() => navigate("/bug-reports")}
            className="w-full sm:w-auto"
          >
            <Bug className="mr-2" />
            Report Bug
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;